<template>
  <div class="widget-item messages-board" :id="widget.object.wid" :style="style">
    <MessagesBoardViewer
      :widgetData="widget.object"
      :appId="widget.object.wid"
      @saveData="saveAppData"
    />
  </div>
</template>

<script>
  import MessagesBoardViewer from '@/components/apps/messages/MessagesBoardViewer.vue';

  import templateWidget from '@/components/widgets/templates/mixins/templateWidget';

  import { simpleTypeMixin } from '@/helpers';
  import { SET_APP_DATA } from '@/store/actions/player';

  export default {
    name: 'MessagesBoardWidget',

    components: { MessagesBoardViewer },

    mixins: [simpleTypeMixin, templateWidget],

    props: {
      widget: {
        type: Object,
        required: true,
      },
    },

    computed: {
      style() {
        return Object.assign({}, this.defaultStyling(this.widget), {
          overflow: 'hidden',
        });
      },
    },
    methods: {
      saveAppData(data = null) {
        this.$store.commit(SET_APP_DATA, {
          appId: this.widget.object.wid,
          appData: { appType: this.widget.object.item_type, data },
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .widget-item {
    position: absolute;
    overflow: hidden;
  }

  .messages-board {
    overflow: hidden;
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
  }
</style>
